/* SUBUMI — Saved (wishlist) and Recently viewed.
   Both are browser-side stores, so neither needs an account and neither
   touches store data. Kept in one file because they share the same storage
   plumbing and the same card markup.

   Saved:    a set of product handles, newest first.
   Recent:   the last 8 handles viewed, newest first, current product excluded.

   Storage can throw — private browsing, quota, disabled cookies — so every
   read and write is guarded. A visitor with storage off loses the feature,
   not the page. */
(function () {
  var KEY_SAVED = 'subumi:saved';
  var KEY_SEEN  = 'subumi:recent';
  var SEEN_MAX  = 8;

  function read(key) {
    try {
      var v = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) { return []; }
  }
  function write(key, list) {
    try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) { /* storage unavailable */ }
  }

  var Saved = {
    all:  function () { return read(KEY_SAVED); },
    has:  function (h) { return read(KEY_SAVED).indexOf(h) > -1; },
    toggle: function (h) {
      var l = read(KEY_SAVED), i = l.indexOf(h);
      if (i > -1) { l.splice(i, 1); } else { l.unshift(h); }
      write(KEY_SAVED, l);
      broadcast();
      return i === -1;
    },
    remove: function (h) {
      var l = read(KEY_SAVED), i = l.indexOf(h);
      if (i > -1) { l.splice(i, 1); write(KEY_SAVED, l); broadcast(); }
    }
  };

  var Recent = {
    all: function () { return read(KEY_SEEN); },
    push: function (h) {
      if (!h) return;
      var l = read(KEY_SEEN), i = l.indexOf(h);
      if (i > -1) l.splice(i, 1);
      l.unshift(h);
      write(KEY_SEEN, l.slice(0, SEEN_MAX));
    }
  };

  function broadcast() {
    var n = Saved.all().length;
    document.querySelectorAll('[data-saved-count]').forEach(function (el) {
      el.textContent = n;
      // The nav entry only earns its place once something is in it.
      var wrap = el.closest('[data-saved-link]');
      if (wrap) wrap.hidden = n === 0;
    });
    document.dispatchEvent(new CustomEvent('subumi:saved-changed', { detail: { count: n } }));
  }

  function paint(btn, on) {
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Remove from saved' : 'Save for later');
    btn.classList.toggle('is-on', on);
  }

  function syncAll() {
    document.querySelectorAll('[data-save]').forEach(function (btn) {
      paint(btn, Saved.has(btn.getAttribute('data-save')));
    });
    broadcast();
  }

  // Delegated so cards rendered later — quick view, recently viewed — work too.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-save]');
    if (!btn) return;
    // Cards are anchors; the heart must not navigate.
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-save');
    var now = Saved.toggle(handle);
    document.querySelectorAll('[data-save="' + handle + '"]').forEach(function (b) { paint(b, now); });
    if (now && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      btn.classList.remove('just-on');
      void btn.offsetWidth;
      btn.classList.add('just-on');
    }
    if (btn.hasAttribute('data-save-removes')) {
      var card = btn.closest('[data-saved-card]');
      if (card) card.remove();
      var grid = document.querySelector('[data-saved-grid]');
      if (grid && !grid.children.length) location.reload();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncAll();
    var pdp = document.querySelector('[data-product-handle]');
    if (pdp) Recent.push(pdp.getAttribute('data-product-handle'));
    renderRecent();
  });

  /* ---- Recently viewed ---------------------------------------------------
     Cards are fetched as rendered HTML from the card-render section rather
     than rebuilt in JS, so they stay identical to every other card on the
     site and pick up any future card change for free. */
  function renderRecent() {
    var host = document.querySelector('[data-recent]');
    if (!host) return;
    var exclude = host.getAttribute('data-recent-exclude') || '';
    var list = Recent.all().filter(function (h) { return h !== exclude; }).slice(0, 4);
    if (!list.length) { host.remove(); return; }

    Promise.all(list.map(function (h) {
      return fetch('/products/' + h + '?section_id=subumi-card-render')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (chunks) {
      var grid = host.querySelector('[data-recent-grid]');
      var html = chunks.map(function (c) {
        if (!c) return '';
        var m = c.indexOf('<div'), n = c.lastIndexOf('</div>');
        return m > -1 && n > -1 ? c.slice(m, n + 6) : '';
      }).filter(Boolean).join('');
      if (!html) { host.remove(); return; }
      grid.innerHTML = html;
      host.hidden = false;
      syncAll();
    });
  }

  window.SubumiSaved = { Saved: Saved, Recent: Recent, sync: syncAll };
})();
